// --------------------------------------------------------------------------
// Disable submit
// --------------------------------------------------------------------------
// Author:      Mike Simmonds
// Email:       frontend@zonedigital.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2017, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

module.exports = function (options) {
    var ref = { $root: options.context };

    function init() {
        ref.$form = ref.$root.find('form');
        ref.$button = ref.$root.find('[data-name="form-submit"]');
        ref.$dummyButton = ref.$button.clone().css('display', 'block').hide().prop('disabled', true).insertAfter(ref.$button);

        // Listen for form submits
        ref.$form.on('submit', function () {
            if (ref.$form.valid()) {
                ref.$button.hide();
                ref.$dummyButton.show();
            }
        });

        // Listen for resetting submit buttons
        ref.$form.on('reset-submit', function () {
            ref.$button.show();
            ref.$dummyButton.hide();
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/disable-submit.js
// module id = 281
// module chunks = 0